import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'monthsAmountLabel',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class MonthsAmountPipe implements PipeTransform {
  transform(leaseTerms: string): string {
    if (!leaseTerms) return '';

    if (leaseTerms === '1') return `${leaseTerms} Month`;

    return `${leaseTerms} Months`;
  }
}
